import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const TopUpPending = () => {
    const stateKey = useStateKey();

    const {
        data: applicationResponse,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () => fetchGetApplication({ stateKey })
    });

    if (isLoading || isError) return null;

    const requestedAmount =
        applicationResponse.data!.requested_products![0]!.amount;

    const requestedCashAmount =
        applicationResponse.data!.requested_products![0].requested_cash_amount;

    return (
        <TopUpStatusMessage
            heading={
                <FormattedMessage
                    id="_.outstanding_view.topupPendingTitle"
                    defaultMessage="Additional funds requested"
                />
            }
            description={
                requestedCashAmount ? (
                    <FormattedMessage
                        id="_.outstanding_view.topupPending"
                        defaultMessage="Thanks for your application for an additional {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedCashAmount}
                                    />
                                </strong>
                            )
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.outstanding_view.topupPendingFallbackDescription"
                        defaultMessage="Thanks for your application for a top up to a credit limit of {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedAmount!}
                                    />
                                </strong>
                            )
                        }}
                    />
                )
            }
            ctaText={
                <FormattedMessage
                    id="_.outstanding_view.changeTopRequest"
                    defaultMessage="Change request"
                />
            }
            trackEvent={() => tracking.ampli.topupChangeRequestCtaClicked()}
        />
    );
};
